import { ElementType } from "lib/enums/enums";
import { FormControlModel } from "types";
import DatePickerForm from "ui/molecules/DatePickerForm";
import SelectForm from "ui/molecules/SelectForm";
import RadioGroupForm from "ui/molecules/RadioGroupForm";
import CheckboxGroupForm from "ui/molecules/CheckboxGroupForm";
import TextFieldForm from "ui/molecules/TextFieldForm";
import TextFieldAdormentForm from "ui/molecules/TextFieldAdormentForm";

const FormComponentFactory = (formModel: FormControlModel) => {
  switch (formModel.elementType) {
    case ElementType.Select:
      return <SelectForm {...formModel} />;
    case ElementType.Textfield:
      return <TextFieldForm {...formModel} />;
    case ElementType.DatePicker:
      return <DatePickerForm {...formModel} />;
    case ElementType.Radio:
      return <RadioGroupForm {...formModel} />;
    case ElementType.Checkbox:
      return <CheckboxGroupForm {...formModel} />;
    case ElementType.AdormentTextfield:
      return <TextFieldAdormentForm {...formModel} />;
  }
};

export default FormComponentFactory;
